var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29289 6.29289C1.68342 5.90237 2.31658 5.90237 2.70711 6.29289L11.2929 14.8787C11.6834 15.2692 12.3166 15.2692 12.7071 14.8787L21.2929 6.29289C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289C23.0976 6.68342 23.0976 7.31658 22.7071 7.70711L14.1213 16.2929C12.9497 17.4645 11.0503 17.4645 9.87868 16.2929L1.29289 7.70711C0.902369 7.31658 0.902369 6.68342 1.29289 6.29289Z",
    fill: "#97A0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownIcon);
export default __webpack_public_path__ + "static/media/AngleDownIcon.c35805fd97e57d775baf1881668dfb8c.svg";
export { ForwardRef as ReactComponent };